import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import Payment from "./Payment";
import { User } from "types/user";
import { Screens } from "types/general";

interface Props {
	onSuccess: () => void;
	setScreen: (v: Screens) => void;
}
export default function Index({ onSuccess, setScreen }: Props) {
	const [user, setUser] = useState<User>();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		authenticateUser();
	}, []);

	const authenticateUser = async () => {
		try {
			const user = await Auth.currentAuthenticatedUser();
			setUser(user);
		} catch (err) {
			//TODO
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{isLoading && <p>loading...</p>}
			{user && <Payment user={user} onSuccess={onSuccess} setScreen={setScreen} />}
		</>
	);
}
